import {makeHoverPattern} from "./utils";
import {WhileLoopTree} from "../model";
import {Keyword} from "../lexer";

const while_ = makeHoverPattern(
	[WhileLoopTree, Keyword.while] as const,
	(_chain, scope, whileLoop, whileToken) => {
		return "A <code>while</code> loop lets us execute code repeatedly. Once the condition is false, the loop stops and execution continues from after the while loop.";
	}
);

export const CONTROL_FLOW_HOVERS = [while_];
